<div class="phx-drag-item-card-content-container">
  <phx-drag-handle *ngIf="!isViewMode" [phxInteractive]="!phxWholeCardDraggable"></phx-drag-handle>
  <div class="phx-drag-item-card-content">
    <ng-content></ng-content>
  </div>
</div>
<ng-content select="[phx-drag-item-card-footer]"></ng-content>

<ng-template #dragItemPlacehoder>
  <div
    class="phx-drag-item-placeholder"
    [ngStyle]="placeholderStyles"
    [ngClass]="phxPlaceholderClass"
  ></div>
</ng-template>
